/**
 ShapeDiver 3D Viewer Application

 CommPluginConstants.js

 Content:
   Definition of constants used by the comm plugin
     - model view interface url
     - ajax timeout
     - ...

  Copyright (c) 2018 ShapeDiver GmbH

  @module CommPluginConstants
 */

var baseUrl = 'https://model-view.shapediver.com:443';

/**
  Definition of default settings for the plugins
 */
var defaultSettings = {
  modelViewUrl: baseUrl,
  ajaxTimeout: 30000,
  ignoreSuperseded: true
};

var commPluginConstants = {
  defaultSettings: defaultSettings
};

/**
  * Global utilities
  */
var GlobalUtils = require('../../shared/util/GlobalUtils');

/**
  Export a deep copy of the constants
 */
module.exports = GlobalUtils.deepCopy(commPluginConstants);
